import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "@factory/design-system/styles.css";
import "./mobiscroll/style.scss";

import { lazy, Suspense, useEffect } from "react";
import { ToastContainer } from "@factory/design-system";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConnectedRouter } from "connected-react-router/immutable";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

import Loading from "../components/common/Loading";
import PrintPage from "../components/common/PrintPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import NewPasswordPage from "../pages/ForgotPasswordPage/NewPasswordPage";
import SignupPage from "../pages/SignupPage";
import store from "../redux/store";

import AuthRoutes from "./AuthRoutes";
import history from "./history";
import queryClient from "./queryClient";

const LoginPage = lazy(() => import("../pages/LoginPage"));
const RootPage = lazy(() => import("../pages/RootPage"));
const InviteTeamMemberPage = lazy(() => import("../pages/InviteTeamMemberPage"));
const OrderDrawingPage = lazy(() => import("../pages/OrderDrawingPage"));

const App = () => {
  useEffect(() => {
    const handlePopState = () => {
      const currentPath = window.location.pathname + window.location.search;

      if (history.location.pathname + history.location.search !== currentPath) {
        history.replace(currentPath);
      }
    };

    window.addEventListener("popstate", handlePopState);

    window.addEventListener("load", () => {
      history.replace({
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        state: history.state || undefined,
      });
    });

    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <Suspense fallback={<Loading className="vh-100" />}>
      <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <QueryClientProvider client={queryClient}>
              <Switch>
                <Route exact path="/" component={RootPage} />
                <Route exact path="/print" component={PrintPage} />
                <Route exact path="/login" component={LoginPage} />
                <Route exact path="/forgot-password" component={ForgotPasswordPage} />
                <Route
                  exact
                  path="/set-password/:encoded_email/:token"
                  component={NewPasswordPage}
                />
                <Route path="/signup" component={SignupPage} />
                <Route path="/invite" component={InviteTeamMemberPage} />
                <Route
                  path="/customer/:customerUid/order-drawings/:orderUid/:token/:drawingUid?"
                  component={OrderDrawingPage}
                />
                <AuthRoutes />
              </Switch>
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </ConnectedRouter>
        </Provider>
      </GoogleOAuthProvider>
      <ToastContainer />
    </Suspense>
  );
};

export default App;
